module.exports = __webpack_public_path__ + "static/media/max_ye.b4469b83.png";